import { CALCULATOR_SCENARIO_VARIANT } from "constants/calculator";

import { convertValueToLocale } from "helpers/convertValueToLocale";

import styles from "./IrrCard.module.scss";

export const getIrr = ({
  conclusionsPro,
  userScenarioResult,
  activePosition,
}) => {
  let irr = 0;
  if (userScenarioResult === CALCULATOR_SCENARIO_VARIANT.POSITIVE) {
    irr = conclusionsPro?.cashFlowConclusions?.irrPositive?.[activePosition];
  } else if (userScenarioResult === CALCULATOR_SCENARIO_VARIANT.NEUTRAL) {
    irr = conclusionsPro?.cashFlowConclusions?.irrNeutral?.[activePosition];
  } else if (userScenarioResult === CALCULATOR_SCENARIO_VARIANT.NEGATIVE) {
    irr = conclusionsPro?.cashFlowConclusions?.irrNegative?.[activePosition];
  }
  return irr;
};

export const getIrrConclusion = (irr) => {
  if (irr >= 10) {
    return {
      title: `Dein Eigenkapitalrendite (IRR-Methode)`,
      value: convertValueToLocale(irr, 2, "%"),
      description: `Ein hoher Eigenkapitalrendite (IRR-Methode) bedeutet, dass das Verhältnis zwischen
                Kaufpreis, Mieteinnahmen und Wertsteigerungspotenzial optimal ist.
                Solche Objekte gelten als erstklassige Investments, da sie eine hohe
                Rendite und einen stabilen Cashflow versprechen. Professionelle
                Investoren sehen eine solche Kennzahl als Zeichen für ein sehr
                lohnenswertes Geschäft.`,
    };
  }

  if (irr >= 7) {
    return {
      title: `Dein Eigenkapitalrendite (IRR-Methode)`,
      value: convertValueToLocale(irr, 2, "%"),
      description: `Ein solcher Eigenkapitalrendite (IRR-Methode) deutet auf eine sehr effiziente Investition
                hin. Kaufpreis und erwartete Erträge stehen in einer guten Balance, was
                ein überdurchschnittliches Kapitalwachstum sichert. Dies ist ein
                Anzeichen für ein qualitativ hochwertiges Objekt in einer
                zukunftsträchtigen Lage.`,
    };
  }

  if (irr >= 5) {
    return {
      title: `Dein Eigenkapitalrendite (IRR-Methode)`,
      value: convertValueToLocale(irr, 2, "%"),
      description: `Dies ist die Kennzahl für eine solide, marktübliche
                Investition. Die Rendite deckt die Risiken ab, und es wird ein stabiles
                W ertwachstum erwartet. Für professionelle Investoren k ö nnte ein
                solches Objekt jedoch nicht optimal sein. Es ist wichtig, auf weitere
                Parameter wie Lage und Ausstattungsqualität zu achten, um die
                zukünftige Nachfrage zu sichern.`,
    };
  }

  return {
    title: `Dein Eigenkapitalrendite (IRR-Methode) von <span class="${
      styles.chartTitleNegative
    }">${convertValueToLocale(irr, 2, "%")}</span>
              ist ein schwaches Ergebnis. Dein
              Kapitalwachstum übersteigt kaum die Inflation, die Investition ist
              ineffizient.`,
    description: `Ein niedriger Eigenkapitalrendite (IRR-Methode) signalisiert ein hohes Risiko. Entweder
              ist der Kaufpreis zu hoch oder die potenziellen Mieteinnahmen sind zu
              gering. Eine solche Investition ist stark von einem zukünftigen,
              unvorhersehbaren Marktwachstum abhängig. Professionelle Investoren
              meiden Objekte mit einer solchen Kennzahl in der Regel aufgrund des
              ungünstigen Risiko - Rendite -V erhältnisses.`,
  };
};
